import React, { useEffect, useState } from "react";
import { Box, Button, TextField, MenuItem } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import Swal from "sweetalert2";
import Header from "../../../components/Header";
import {
  generateAndExecuteMutation,
  graphqlQuery,
} from "../../../data/Axios/DynamicService";
import { salesManagement, setupManagementUrl } from "../../../config";
import { DiscountTypesQuery } from "../../../data/Axios/queries";

const base_url = setupManagementUrl.uri;

const SellingPriceRulesForm = (props) => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const [discounttypesData, setDiscountTypesData] = useState([]);
  const [selectedDiscountType, setSelectedDiscountType] = useState("");
  const userId = parseInt(decodedToken.Id);
  const CompanyId = parseInt(decodedToken.CompanyId);
  const RegionId = parseInt(decodedToken.RegionId);
  const BranchId = parseInt(decodedToken.BranchId);

  const initialValues = {
    percentage: props.data ? props.data.percentage : "",
  };

  const validationSchema = yup.object().shape({
    // discountFlatAmount: yup.string().required("Discount Flat Amount is required"),
    percentage: yup.string().required("Minimum Purchase Amount is required"),
    // discountPercentage: yup.string().required("Discount Percentage is required"),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const { percentage } = values;

      const mutationData = {
        percentage,
      };

      if (props.isEditing) {
        mutationData.id = props.data.id;
      }
      const response = await generateAndExecuteMutation(
        props.isEditing
          ? "updateSellingPricePercentageRules"
          : "createSellingPricePercentageRules",
        mutationData,
        "sellingPriceRules",
        base_url
      );
      if (response) {
        props.onClose();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `Selling Price Rule ${
            props.isEditing ? "updated" : "created"
          } successfully.`,
        }).then(() => {
          props.refetchData();
        });
      }
    } catch (error) {
      props.onClose();
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "The rule already set. Try to update the existing rule!",
      });
    }

    setSubmitting(false);
  };

  return (
    <Box m="20px" bgcolor="background.paper" p={3}>
      <Header
        title={props.isEditing ? "Edit Discount Rule" : "Create Discount Rule"}
        subtitle={
          props.isEditing
            ? "Edit an existing Discount Rule"
            : "Create a new Discount Rule"
        }
      />

      <Formik
        onSubmit={handleSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box display="grid" gap="30px">
              <TextField
                fullWidth
                variant="filled"
                type="number"
                label="Selling Price Percentage(%)"
                onBlur={handleBlur}
                onChange={handleChange} // Use Formik's handleChange to update the value
                value={values.percentage}
                name="percentage"
                error={touched.percentage && !!errors.percentage}
                helperText={touched.percentage && errors.percentage}
              />
              <Button
                type="submit"
                color="secondary"
                variant="contained"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Submit"}
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </Box>
  );
};

export default SellingPriceRulesForm;
